




































































import Vue from 'vue'
import CollectionExplorer from '@/components/DataExplorer/CollectionExplorer.vue'
import {
  CollectionInfo,
  DataExplorerService,
  ExplorerSource
} from '@/api/services/data-explorer'

interface ComponentData {
  source: ExplorerSource
  sources: { value: ExplorerSource; label: string }[]
  collections: CollectionInfo[]
  collection: string
  loadingCollections: boolean
  collectionsError: string
}

export default Vue.extend({
  components: {
    MongoCollectionExplorer: CollectionExplorer
  },

  data(): ComponentData {
    return {
      source: 'v2',
      sources: [
        { value: 'v2', label: 'V2' },
        { value: 'v1', label: 'V1' }
      ],
      collections: [],
      collection: '',
      loadingCollections: false,
      collectionsError: ''
    }
  },

  mounted() {
    this.fetchCollections()
  },

  methods: {
    changeSource(source: ExplorerSource) {
      if (this.source === source) return
      this.source = source
      this.collection = ''
      this.fetchCollections()
    },

    async fetchCollections() {
      this.loadingCollections = true
      this.collectionsError = ''
      this.collections = []

      try {
        this.collections = await DataExplorerService.listCollections(
          this.source
        )
      } catch (error) {
        const data = error?.response?.data
        this.collectionsError =
          (data && data.message) ||
          error?.message ||
          'Impossible de charger les collections'
      } finally {
        this.loadingCollections = false
      }
    }
  }
})
